import type { DispersionsTranslations } from "../interfaces/dispersions";

export const dispersionsTranslations: DispersionsTranslations = {
  header_title: "Enviar dinheiro",
  header_subtitle: "De forma imediata e direta para quem recebe",
  header_chip: "Novo envio",
  step_1_title: "Conversão de Moeda",
  step_2_title: "Informações do Destinatário",
  step_3_title: "Confirmação",
  stepper_amount: "Valor",
  stepper_recipient: "Destinatário",
  stepper_review: "Revisão",

  balance_label: "Saldo Disponível",

  origin_currency_label: "Moeda de Origem",
  destination_currency_label: "Moeda de Destino",
  select_origin_currency: "Selecionar moeda de origem",
  select_destination_currency: "Selecionar moeda de destino",
  origin_country_label: "País de Origem",
  destination_country_label: "País de Destino",
  amount_origin_label: "Valor a Enviar",
  amount_destination_label: "Valor a Receber",
  conversion_rate_label: "Taxa de Conversão",
  amount_to_send: "Valor a Enviar",
  amount_to_receive: "Valor a Receber",
  fees_label: "Comissão",
  total_deducted_label: "Total a Deduzir",

  fields: {
    phone_number: "Número de Telefone",
    key_number: "Chave",
    pix_type: "Tipo de Chave PIX",
    pix_key: "Chave PIX",
    description: "Descrição",
    clabe: "CLABE",
    recipient: "Destinatário",
    protocol: "Protocolo",
    first_name: "Nome",
    last_name: "Sobrenome",
    identification_type: "Tipo de Identificação",
    identification_number: "Número de Identificação",
    bank: "Banco",
    account_type: "Tipo de Conta",
    account_number: "Número da Conta",
    address: "Endereço",
    city: "Cidade",
    state: "Estado/Província",
    postal_code: "Código Postal",
    birth_date: "Data de Nascimento",
    email: "E-mail",
    gender: "Gênero",
    webhook_url: "URL do Webhook",
    full_name: "Nome Completo",
    document_type: "Tipo de Documento",
    document_number: "Número do Documento",
    network: "Rede",
    wallet: "Carteira",
  },

  placeholders: {
    phone_number: "Ex: 11987654321",
    key_number: "Ex: 3113113113",
    pix_key: "Digite sua chave PIX",
    description: "Digite uma descrição (opcional)",
    clabe_mexico: "646180110400000007",
    recipient: "João Silva",
    account_number: "Digite o número da conta",
    email: "email@exemplo.com",
    first_name: "João",
    last_name: "Silva",
    identification_type: "RUT",
    identification_number: "12345678-9",
    address: "Av. Principal 123",
    city: "Santiago",
    state: "Metropolitana",
    postal_code: "7500000",
    full_name: "João Silva Santos",
    document_number: "1234567890",
    wallet: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb",
    webhook_url: "https://api.exemplo.com/webhook/dispersao",
  },

  helpers: {
    phone_number_colombia: "Deve ser um número de 10 dígitos",
    key_number_colombia: "Deve ser uma chave numérica de 10 dígitos",
    pix_key_cpf: "Digite 11 dígitos do CPF sem formatação",
    pix_key_cnpj: "Digite 14 dígitos do CNPJ sem formatação",
    pix_key_email: "Digite um e-mail válido em minúsculas",
    pix_key_phone: "Digite 9 dígitos do telefone",
    pix_key_evp: "Digite o UUID em formato válido",
    clabe_18_digits: "Deve conter exatamente 18 dígitos",
    webhook_url: "URL para receber notificações (máximo 255 caracteres)",
    document_number_ecuador: "CEDULA: 10 dígitos, RUC: 13 dígitos, PASSAPORTE: 6-9 caracteres",
    identification_number_panama: "CIP: 8 dígitos, PASSAPORTE: 9 caracteres alfanuméricos",
    wallet_address: "Endereço da carteira de destino",
  },

  button_next: "Próximo",
  button_previous: "Anterior",
  button_confirm: "Confirmar",
  button_cancel: "Cancelar",
  button_retry: "Tentar novamente",
  button_continue: "Continuar",
  button_authorize: "Autorizar envio",

  twofa_modal_title: "Verificação em duas etapas",
  twofa_modal_instruction:
    "Digite o código de 6 dígitos do seu aplicativo autenticador para confirmar este envio.",
  twofa_verifying: "Verificando...",

  recipient_client_label: "Cliente",
  recipient_client_loading: "Carregando clientes…",
  recipient_client_placeholder: "Buscar cliente por nome...",
  recipient_account_label: "Conta do cliente",
  recipient_account_loading: "Carregando contas…",
  recipient_account_placeholder: "Selecionar conta...",
  recipient_account_fallback_name: "Conta",
  recipient_pix_type_label: "Tipo de chave PIX",
  recipient_pix_type_placeholder: "Selecione o tipo de chave...",
  recipient_description_label: "Descrição",
  recipient_description_placeholder: "Descrição do envio",
  footer_rate_note: "Os valores ficam fixos com a taxa desta cotação até expirar.",

  error_create_failed: "Não foi possível criar o envio",
  error_client_required: "Selecione um cliente",
  error_client_account_required: "Selecione uma conta do cliente",
  error_description_required: "A descrição é obrigatória",
  error_pix_key_invalid: "Insira uma chave PIX válida",
  error_recipient_name_required: "Insira o nome do destinatário",
  error_clabe_invalid: "Insira uma CLABE válida de 18 dígitos",
  error_cbu_cvu_invalid: "Insira um CBU/CVU válido de 22 dígitos",
  error_cuit_invalid: "O CUIT/CUIL deve ter 11 dígitos",
  error_breb_key_invalid: "Insira uma chave Bre-B válida",
  error_no_organization: "Seu usuário não tem uma organização associada para criar o envio.",
  error_payment_rejected:
    "O pagamento foi rejeitado pelo banco de destino. Verifique os dados do destinatário e tente novamente.",
  error_origin_required: "Selecione a moeda de origem",
  error_destination_required: "Selecione a moeda de destino",
  error_amount_required: "Insira um valor",
  error_amount_positive: "O valor deve ser maior que 0",
  loading_quote: "Obtendo cotação...",
  loading_balance: "Carregando saldo...",

  confirmation_review_title: "Revise os Detalhes",
  confirmation_amount_section: "Informações do Valor",
  confirmation_recipient_section: "Informações do Destinatário",

  step_conversion_title: "Conversão",
  step_recipient_title: "Destinatário",
  step_confirmation_title: "Confirmação",

  quote_valid_for: "Esta taxa é válida por",
  quote_expiring_soon: "A cotação expirará em breve",
  quote_expired_message: "A cotação expirou",
  quote_expired_modal_title: "Cotação Expirada",
  quote_expired_modal_message:
    "A taxa de câmbio expirou. Para continuar com seu envio, você precisa recalcular a cotação com as taxas atuais.",
  quote_expired_modal_hint: "Você também pode começar do início se quiser alterar valores ou destinos.",
  quote_expired_recalculate: "Recalcular Cotação",
  quote_expired_start_over: "Começar Novamente",

  register_client_button: "Cadastrar cliente",
  client_kyc_blocked_note:
    "O cliente selecionado ainda não concluiu a verificação de identidade (KYC). Você não poderá continuar com o envio até que ele seja verificado.",
  client_kyc_unavailable_note:
    "Não foi possível verificar o status de identidade (KYC) dos seus clientes. Por segurança, não é possível continuar com o envio até concluir a verificação.",
  client_kyc_retry_button: "Tentar novamente",
  register_account_button: "Cadastrar conta",
  client_not_verified_badge: "Não verificado",
  recipient_use_client_label: "Enviar para um cliente cadastrado",
  recipient_manual_hint: "Digite os dados de quem recebe. Não precisa tê-lo cadastrado.",
  recipient_use_client_hint: "Escolha um cliente e preenchemos os dados de recebimento.",
  step1_no_wallets_note: "Você não tem carteiras ativas. Ative uma em Carteiras para poder enviar.",
  step1_origin_wallet_frozen_badge: "Congelada",
  step1_cross_currency_hint:
    "Convertemos de {{origin}} para {{destination}} na confirmação; a taxa fica fixa nesta cotação.",
  step1_same_currency_hint: "Você envia e o destinatário recebe em {{currency}} — sem conversão.",
  runtime_wallet_missing: "Você não tem uma carteira em {{currency}}. Ative em Carteiras.",
  quote_breakdown_title: "Detalhamento da cotação",
  quote_conversion_fee_label: "Taxa de conversão",
  quote_converted_amount_label: "Valor convertido",
  quote_dispersion_fee_label: "Taxa de envio",
  quote_recalculated_note: "Atualizamos os valores com a taxa atual. Revise antes de autorizar.",
  error_quote_required: "É necessária uma cotação válida para autorizar o envio.",
  error_quote_expired: "A cotação expirou. Recalcule para continuar.",
  error_quote_pricing: "Estamos atualizando a cotação. Aguarde um momento.",
  error_quote_already_used:
    "Esta cotação já foi utilizada. Verifique seu histórico antes de tentar novamente.",
  error_payout_unconfirmed:
    "Não foi possível confirmar o estado desta operação. Verifique seu histórico antes de tentar novamente.",
  result_error_check_activity: "Ver histórico de atividade",
  error_verification_required:
    "Sua conta ainda não está verificada. Conclua a verificação para poder enviar dinheiro.",
  result_error_go_verify: "Ir para a verificação",
  error_quote_invalid: "Não foi possível usar esta cotação. Recalcule e tente novamente.",
  error_unsupported_corridor: "Este corredor não está disponível para envios.",
  runtime_wallet_frozen_warning:
    "Sua carteira {{currency}} está congelada: não é possível enviar dinheiro no momento.",
  runtime_insufficient_funds:
    "Saldo insuficiente na sua carteira {{currency}}. Você pode enviar até {{max}}.",
  runtime_balance_error: "Não foi possível carregar o saldo da sua carteira {{currency}}.",

  result_processing_title: "Enviando seu dinheiro…",
  result_processing_subtitle: "Estamos fazendo o envio. Isso leva alguns segundos.",
  result_status_created: "Pendente de envio",
  result_status_paid: "Entregue",
  result_status_processing: "Processando no banco",
  result_status_failed: "Rejeitado",
  result_status_cancelled: "Cancelado",
  result_status_reversed: "Devolvido",
  result_success_title: "Envio realizado",
  result_pending_title: "Envio a caminho",
  result_rejected_title: "O envio não foi concluído",
  result_receipt_to: "para",
  result_success_sent_note: "O dinheiro já está na conta de destino.",
  result_success_created_note: "Foi registrado e sai em breve.",
  result_pending_sent_note: "Falta a confirmação do banco de destino.",
  result_rejected_note: "O dinheiro voltou para a sua carteira.",
  result_rejected_note_converted:
    "O dinheiro ficou disponível na sua carteira de {{currency}}, não na de origem: a conversão já tinha sido feita e não é revertida. A taxa de conversão não é reembolsada.",
  result_pending_live_hint: "Esta tela se atualiza sozinha assim que o banco confirmar o envio.",
  result_reference_label: "Referência",
  result_reference_copy: "Copiar a referência",
  result_reference_copied: "Referência copiada",
  route_label: "Rota",
  send_label: "Você envia",
  concept_label: "Descrição",
  result_show_details: "Ver detalhes",
  result_hide_details: "Ocultar detalhes",
  receipt_save_recipient: "Salvar este destinatário",
  receipt_save_recipient_done: "Salvo. Da próxima vez você o escolhe na sua lista de clientes.",
  receipt_save_recipient_partial:
    "Criamos o cliente, mas a conta dele não foi salva. Você pode adicioná-la em Clientes.",
  result_send_again: "Enviar novamente",
  result_send_again_pending_hint:
    "Disponível quando a transferência for resolvida. Repeti-la agora seria um segundo pagamento ao mesmo destinatário.",
  result_send_to_someone_else: "Enviar para outra pessoa",
  result_back_to_wallets: "Voltar para minhas carteiras",
  result_error_title: "Não foi possível enviar o dinheiro",
  result_error_fallback: "Verifique os dados do destinatário ou tente novamente em alguns minutos.",
  result_error_adjust: "Ajustar dados",

  quote_rate_valid_for: "Taxa válida por",
  quote_receives_label: "Recebe:",
  quote_exchange_rate_label: "Taxa de câmbio",
  quote_total_debit_label: "Total a debitar da sua conta",
  quote_recipient_receives_label: "O destinatário recebe",

  rail_label: "Trilho",
  rail_transfer: "Transferência",
  rail_crypto: "Cripto",

  step1_origin_label: "Você envia de",
  step1_destination_label: "O destinatário recebe em",
  step1_select_placeholder: "Selecione…",
  step1_origin_account_title: "Conta de origem",
  step1_available_balance: "Saldo disponível",
  step1_refresh_balance: "Atualizar saldo",
  step1_amount_placeholder: "0,00",
  step1_amounts_hint: "Edite qualquer um dos dois — o outro é calculado com a taxa.",
  step1_quote_loading: "Calculando taxa…",
  step1_quote_error: "Não foi possível obter a taxa.",
  error_amount_above_max: "O valor excede o máximo de {{limit}} deste corredor.",
  error_amount_below_min: "O valor está abaixo do mínimo de {{limit}} deste corredor.",
  step1_limit_hint_range: "Este corredor aceita de {{min}} a {{max}} por envio.",
  step1_limit_hint_max: "Este corredor aceita até {{max}} por envio.",
  step1_limit_hint_min: "Este corredor exige pelo menos {{min}} por envio.",
  step2_limit_blocked:
    "Com este método e destinatário o valor fica fora do limite permitido ({{limit}}). Ajuste o valor para continuar.",
  step2_limit_back: "Voltar ao valor",

  step2_client_label: "Cliente",
  step2_client_loading_placeholder: "Carregando clientes…",
  step2_client_placeholder: "Selecione um cliente…",
  step2_account_label: "Conta do destinatário ({{currency}})",
  step2_account_placeholder: "Selecione uma conta…",
  step2_account_fallback_label: "Conta",
  step2_no_accounts_note: "Este cliente não tem contas em {{currency}}.",
  step2_recipient_section_title: "Quem vai receber o dinheiro",
  step2_recipient_name_label: "Nome do destinatário",
  step2_recipient_name_placeholder: "Nome completo ou razão social",
  step2_concept_placeholder: "Pagamento a fornecedor · fatura 1042",
  step2_separator_brazil: "DADOS DO DESTINO · BRASIL → PIX",
  step2_separator_mexico: "DADOS DO DESTINO · MÉXICO → SPEI",
  step2_separator_argentina: "DADOS DO DESTINO · ARGENTINA → CBU/CVU",
  step2_pix_type_label: "Tipo de chave PIX",
  step2_clabe_placeholder: "18 dígitos",
  step2_clabe_error: "A CLABE deve ter 18 dígitos.",
  step2_clabe_helper: "18 dígitos, sem espaços nem hífens.",
  step2_account_type_cvu: "CVU (carteira)",
  step2_account_type_cbu: "CBU (banco)",
  step2_cbu_cvu_placeholder: "22 dígitos",
  step2_cbu_cvu_error: "O {{type}} deve ter 22 dígitos.",
  step2_cbu_cvu_helper: "22 dígitos, sem espaços nem hífens.",
  step2_cuit_label: "CUIT/CUIL do destinatário",
  step2_cuit_placeholder: "11 dígitos, sem hífens",
  step2_cuit_error: "O CUIT/CUIL deve ter 11 dígitos.",
  step2_cuit_helper: "Opcional. Ajuda o banco de destino a validar o titular.",
  // Colômbia · TRANSFIYA (ACH en línea)
  step2_col_rail_label: "Método de envio",
  col_rail_breb: "Chave Bre-B",
  col_rail_transfiya: "Conta bancária (Transfiya)",
  col_rail_unavailable: "Temporariamente indisponível. Tente mais tarde.",
  col_rail_not_configured: "Ainda não disponível para a sua organização.",
  col_rail_balance_low: "Temporariamente desabilitado. Tente outro método.",
  col_rail_balance_low_try_breb: "Temporariamente desabilitado. Tente por Bre-B.",
  step2_separator_colombia_transfiya: "DADOS DO DESTINO · COLÔMBIA → TRANSFIYA",
  step2_tf_bank_label: "Banco de destino",
  step2_tf_bank_placeholder: "Selecione um banco",
  step2_tf_bank_loading: "Carregando bancos…",
  step2_tf_bank_error: "Não foi possível carregar a lista de bancos. Recarregue a página.",
  step2_tf_account_type_label: "Tipo de conta",
  tf_account_type_savings: "Poupança",
  tf_account_type_checking: "Corrente",
  tf_account_type_deposit: "Depósito de baixo valor",
  tf_account_type_standard_deposit: "Depósito ordinário",
  tf_account_type_inclusive_deposit: "Depósito inclusivo",
  step2_tf_account_number_label: "Número da conta",
  step2_tf_account_number_placeholder: "Somente números",
  step2_tf_doc_type_label: "Tipo doc.",
  step2_tf_doc_number_label: "Documento do destinatário",
  step2_tf_doc_number_placeholder: "Somente números",
  error_tf_account_number_invalid: "Insira um número de conta válido",
  error_tf_bank_required: "Selecione o banco de destino",
  error_tf_doc_number_invalid: "Insira o documento do destinatário",
  step3_tf_bank_label: "Banco de destino",
  step3_tf_account_label: "Conta",
  step3_tf_doc_label: "Documento",
  step2_breb_key_label: "Chave Bre-B",
  step2_breb_key_helper: "Deve estar registrada como chave Bre-B de quem recebe.",
  step2_breb_key_placeholder_phone: "300 123 4567",
  step2_breb_key_placeholder_email: "email@exemplo.com",
  step2_breb_key_placeholder_alphanum: "@chave",
  step2_breb_key_placeholder_nric: "Número do documento",
  step2_breb_key_placeholder_merchant: "Código de comércio",
  step2_breb_key_error_phone: "Insira um celular válido de 10 dígitos.",
  step2_breb_key_error_email: "Insira um e-mail válido.",
  step2_breb_key_error_alphanum: "Insira uma chave alfanumérica válida.",
  step2_breb_key_error_nric: "Insira um documento válido.",
  step2_breb_key_error_merchant: "Insira um código de comércio válido.",
  breb_key_type_phone: "Celular",
  breb_key_type_email: "E-mail",
  breb_key_type_alphanum: "Alfanumérica",
  breb_key_type_nric: "Documento",
  breb_key_type_merchant: "Código de comércio",
  breb_lookup_loading: "Consultando a chave no diretório Bre-B…",
  breb_recipient_idle: "Digite a chave e dizemos de quem é",
  breb_recipient_confirmed: "Titular verificado em {{bank}}",
  breb_recipient_no_holder: "A chave está ativa, mas o diretório não devolveu o nome",
  breb_recipient_holder_line: "{{holder}} · {{bank}}",
  breb_recipient_saved_as: "Salvo nos seus clientes como {{name}}",
  breb_status_unknown: "Não foi possível confirmar o status da chave",
  breb_lookup_not_found_detail: "Confirme a chave com quem vai receber o dinheiro.",
  breb_lookup_unavailable_detail:
    "Sem confirmar quem recebe, não é possível enviar. Tente em alguns minutos.",

  breb_lookup_inactive: "A chave existe mas não está ativa. O envio seria rejeitado.",
  breb_lookup_not_found: "Esta chave não está registrada no Bre-B",
  breb_lookup_unavailable: "Não foi possível consultar o diretório Bre-B",
  step3_breb_holder_label: "Titular verificado",
  step3_breb_bank_label: "Entidade",

  step3_summary_title: "Resumo da operação",
  step3_recipient_title: "Quem recebe",
  step3_name_label: "Nome",
  step3_clabe_label: "CLABE",
  step3_account_type_label: "Tipo de conta",
  step3_cuit_label: "CUIT/CUIL",
  step3_breb_key_type_label: "Tipo de chave",
  step3_pix_type_label: "Tipo de chave",
  step3_pix_key_label: "Chave PIX",
  step3_pix_type_email: "E-mail",
  step3_pix_type_phone: "Telefone",
  step3_pix_type_evp: "Chave aleatória",
  step3_irreversible_prefix: "Uma vez autorizado, o envio é",
  step3_irreversible_emphasis: "imediato e irreversível",

  send_title: "Enviar dinheiro",
  send_subtitle: "Da sua carteira {{currency}}",
  send_from_label: "De",
  send_from_wallet: "Carteira {{currency}}",
  send_available: "Disponível {{amount}}",
  send_to_label: "Para",
  send_amount_label: "Quanto você vai enviar?",
  send_fee_switch: "Eu assumo o custo do envio",
  send_fee_on_hint: "A pessoa recebe o valor completo; o custo é somado ao que sai da sua carteira.",
  send_fee_off_hint: "O custo é descontado do que a pessoa recebe.",
  send_row_arrives: "Chega para a pessoa",
  send_row_cost: "Custo do envio",
  send_row_debit: "Sai da sua carteira",
  send_cost_free: "Sem custo",
  send_insufficient:
    "Saldo insuficiente: você tem {{balance}} disponíveis e este envio precisa de {{debit}}.",
  send_quote_error: "Não conseguimos calcular o envio. Tente novamente.",
  send_rail_label: "Como você vai enviar?",
  send_rail_breb_hint: "Chega em segundos a uma chave",
  send_rail_transfiya_hint: "Para uma conta bancária",
  send_recipient_label: "Quem recebe?",
  send_key_label: "Chave Bre-B de quem recebe",
  send_key_placeholder: "Celular, e-mail, documento ou @chave",
  send_key_hint: "Digite como recebeu; nós identificamos o tipo de chave.",
  send_key_type_line: "Chave: {{type}}",
  send_tf_name_label: "Nome do titular da conta",
  send_tf_name_placeholder: "Como aparece no banco",
  send_tf_name_error: "Digite o nome do titular",
  send_concept_label: "Descrição (opcional)",
  send_review: "Revisar envio",
  send_cancel: "Cancelar",
  send_close: "Fechar",
  send_read_only:
    "Você pode ver esta carteira, mas seu usuário não tem permissão para enviar dinheiro. Peça a um administrador da sua organização.",
  send_review_title: "Revise e confirme",
  send_review_arrives_to: "Vai para",
  send_review_key: "Chave",
  send_review_bank: "Banco",
  send_review_account: "Conta",
  send_review_document: "Documento",
  send_review_via: "Via",
  send_review_concept: "Descrição",
  send_review_edit: "Editar",
  send_confirm: "Enviar {{amount}}",
  send_cost_changed: "O custo do envio mudou enquanto você revisava. Confira os valores antes de enviar.",
  send_converts_hint: "Convertemos seus {{from}} em {{to}} dentro do envio, à taxa mostrada abaixo.",
  send_amount_label_arrives: "Quanto a pessoa deve receber?",
  send_amount_label_debit: "Quanto sai da sua carteira?",
  send_fee_on_hint_fx:
    "Você digita o que a pessoa recebe em {{currency}}; o custo e a conversão são somados ao que sai.",
  send_fee_off_hint_fx:
    "Você digita o que sai da sua carteira em {{currency}}; o custo e a conversão são descontados do que chega.",
  send_row_conversion: "Conversão",
  send_rate_label: "Taxa de câmbio",
  send_rate_valid_for: "Preço válido por {{time}}",
  send_rail_pix_hint: "Na hora, para uma chave PIX",
  send_rail_spei_hint: "Para uma conta CLABE",
  send_rail_cbu_cvu_hint: "Para um CBU ou um CVU",
  send_name_label: "Nome de quem recebe",
  send_name_placeholder: "Nome completo ou razão social",
  send_pix_key_hint: "Cole como recebeu; nós identificamos o tipo de chave.",
  send_pix_key_check_error: "Confira o número: os dígitos verificadores não batem.",
  send_clabe_check_error: "Confira a CLABE: o dígito verificador não bate.",
  send_rfc_label: "RFC",
  send_rfc_placeholder: "12 ou 13 caracteres",
  send_rfc_helper: "Opcional. Se for uma empresa, seu RFC de 12 caracteres.",
  send_rfc_error: "Confira o RFC: 12 caracteres para uma empresa, 13 para uma pessoa.",
  send_review_rfc: "RFC",
  send_transit_from: "Sua carteira {{currency}}",
  send_transit_aria: "Enviando {{amount}} para {{name}} em {{country}}",
  send_transit_aria_fx: "Enviando {{debit}}, convertidos em {{amount}}, para {{name}} em {{country}}",
  send_processing_fx: "Convertendo seus {{from}} em {{to}} e enviando…",
};
